import React from 'react';
import './index.css';
import { sendStatsEvent } from '../../statistics';
/**
 * 字数截断
 */
export class Desc extends React.Component{
  constructor(props){
    super(props);
    let _div = document.createElement('p');
    _div.innerHTML = props.desc;
    this.realText = _div.innerText;
    this.state = {
      showAll: this.realText.length > props.number ? false : true
    };
  }
 
  render(){
    let { desc, text, className } = this.props;
    let { showAll } = this.state;
    if(!desc){
      return null;
    }
    desc = showAll ? desc : this.getShortText();
    return(
      <div className={className ? `subfield infoDesc ${className}`:'subfield infoDesc'}>
        {!text ? null : <div className="left">{text}</div>}
        <div className="right">
          <div className="infoDesc" dangerouslySetInnerHTML={{__html: desc}}></div>
          {!showAll && <div className="info-show-more" onClick={this.showAllText}><i className="icon icon-arrow"></i></div> } 
        </div>
      </div>
    );
  }


  getShortText(){
    let { desc, number } = this.props;
    return this.realText.length > number ? this.realText.substring(0, number) + ' ...&nbsp;&nbsp;&nbsp;' : desc;
  }
 
  showAllText = ()=>{
    this.setState({
      showAll: true
    });
  }
}


Desc.defaultProps = {
  number: 36
};







/**
 * 简介 带有展开收起
 */
export class BasicInfo extends React.Component{
  constructor(props){
    super(props);
    let _div = document.createElement('p');
    this.desc = props.desc;
    if(props.wikiUrl && props.wikiUrl.url !== ''){
      this.desc = `${props.desc}<p><a class="wiki-entrance" href="${props.wikiUrl.url}">[维基百科]</a></p>`;
    } 
   
    _div.innerHTML = this.desc;
    this.realText = _div.innerText;
    this.state = {
      needShowMore: this.realText.length > 50 ? true : false,
      showAll: this.realText.length > 50 ? false : true,
    };
  }
 
  render(){
    let { text} = this.props;
    let { needShowMore, showAll } = this.state;
    if(!this.desc){
      return null;
    }
    let desc = showAll ? this.desc : this.getShortText();
    return(
      <div className="subfield desc">
        <div className="left">{text}</div>
        <div className="right">
          <div className="desc" dangerouslySetInnerHTML={{__html: desc}}></div>

          { needShowMore ? 
            <div className="desc-show-more" onClick={this.showAllText}>{showAll ? '收起' : '查看更多'}</div> 
            : null
          } 
        </div>
      </div>
    );
  }


  getShortText(){
    let { desc } = this;
    return this.realText.length > 50 ? this.realText.substring(0, 50) + ' ...&nbsp;&nbsp;&nbsp;' : desc;
  }
 
  showAllText = ()=>{
    let { showAll } = this.state;
    this.setState({
      showAll: !showAll
    });
  }
}








/**
 * 行数截断
 */
export class LineDesc extends React.Component{
  constructor(props){
    super(props);
    this.desc = props.desc;
    if(props.wikiUrl && props.wikiUrl.url !== ''){
      this.desc = `${props.desc}<p><a class="wiki-entrance" href="${props.wikiUrl.url}">[维基百科]</a></p>`;
    } 

    this.state = {
      needShowMore: false,
      showAll: false ,
    };
  }
 
  render(){
    let {className, text, line, useArrow} = this.props;
    let { needShowMore, showAll } = this.state;
    if(!this.desc){
      return null;
    }
    let moreDom = useArrow ? <i className="icon icon-arrow"></i> : '查看更多';
    //let upDom = useArrow ? <i className="icon icon-arrow up"></i> : "收起";
    let lineClamp = showAll ? 'infoDesc' : `infoDesc line-clamp${line}`;
    return(
      <div className={ className ? `subfield ${className}` : 'subfield desc'}>
        <div className="left">{text}</div>
        <div className="right">
          <div className={lineClamp} 
            ref="descContent"
            dangerouslySetInnerHTML={{__html: this.desc}}></div>
          { needShowMore ? 
            <div className="desc-show-more" 
              onClick={this.showAllText}>
              {showAll ? null : moreDom}
            </div> 
            : null
          } 
          <div className="infoDesc-wrap" 
            ref="descRealContent"
            dangerouslySetInnerHTML={{__html: this.desc}}>
          </div>
        </div>
      </div>
    );
  }

  componentDidMount(){
    let $content = this.refs.descContent;
    let $realContent = this.refs.descRealContent;
    if($content && $realContent){ 
      // console.log($content.clientHeight , $realContent.clientHeight);
      if($content.clientHeight < $realContent.clientHeight){
        this.setState({needShowMore: true});
      }
    }
  }

  showAllText = ()=>{
    let { showAll } = this.state;
    let { tjKey } = this.props;
    sendStatsEvent(tjKey);
    this.setState({
      showAll: !showAll
    });
  }
}


LineDesc.defaultProps = {
  line: 2,
  useArrow: false
};



// WEBPACK FOOTER //
// ./src/components/Poi2/Desc/index.js